<template>
<div class="sing-in">
	<div class="sing-in__form fields">
		<div class="fields__item">
			<div class="field-input">
				<label class="field-input__label">Логин</label>
				<input v-model="username" type="text" class="field-input__input" @keyup.enter="login">
			</div>
		</div>
		<div class="fields__item">
			<div class="field-input">
				<label class="field-input__label">Пароль</label>
				<input v-model="password" type="password" class="field-input__input" @keyup.enter="login">
			</div>
		</div>
		<div class="fields__item">
			<vue-recaptcha class="sing-in__google-recaptcha"
			   	ref="recaptcha"
			 	:sitekey="$root.$reCaptchaSiteKey"
			 	@verify="onCaptchaVerified"
			 	@expired="onCaptchaExpired">
			</vue-recaptcha>
		</div>
		<div class="fields__item">
			<button class="btn btn--white btn--block" @click="login" :disabled="disableBtn"> Войти
			</button>
		</div>
	</div>
	<div class="fields sing-in__soc">
		<div class="fields__item">
			<button @click="$root.OAuth('vkontakte')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-vk"></use></svg>
				<span>Войти через Вконтакте</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('telegram')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-tg"></use></svg>
				<span>Войти через Telegram</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('google')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-google"></use></svg>
				<span>Войти через Google</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('mailru')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-mailru"></use></svg>
				<span>Войти через mail.ru</span>
			</button>
		</div>
		<div class="fields__item">
			<button @click="$root.OAuth('yandex')" class="btn btn--block">
				<svg class="btn__icon"><use href="#svg-icon-yandex"></use></svg>
				<span>Войти через yandex</span>
			</button>
		</div>
		<div class="fields__item">
			<div class="sing-in__note">Авторизуясь, вы соглашаетесь с<br>
				<a class="sing-in__note-link" href="terms" target="_blank"> Правилами сайта</a>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';

	export default {
		components: {
			VueRecaptcha
		},

		emits: [
			'close'
		],

		data() {
			return {
				username: '',
				password: '',
				disableBtn: false,
				gRecaptchaResponse: null,
			}
		},

		watch: {
			gRecaptchaResponse(state) {
				if(state && this.username && this.password) {
					this.login();
				}
			}
		},

		methods: {
			login() {
				if (!this.gRecaptchaResponse) {
					return this.$toast.error('Необходимо пройти капчу');
				}

				if (!this.username) {
					return this.$toast.error('Введите имя пользователя');
				}

				if (!this.password) {
					return this.$toast.error('Введите пароль');
				}

				this.disableBtn = true;

				this.$root.graphql.getLoginUser({
					username: this.username,
					password: this.password,
					recaptcha: this.gRecaptchaResponse
				}).then(res => {
					const token = res.token;

					if (token) {
						this.$root.setAuthToken(token);
						this.$root.getUser();
						this.$root.recordUserData();
					}
					
					this.$emit('close');
					this.disableBtn = false;
				}).catch(error => {
					this.disableBtn = false;
					this.$toast.error(this.$root.graphql.getError(error));
					this.$cookie.delete('token');
					this.$refs.recaptcha.reset();
				});
			},

			onCaptchaVerified(response) {
				this.gRecaptchaResponse = response;
			},
			onCaptchaExpired() {
				this.$refs.recaptcha.reset()
			}
		}
	}
</script>